<template>
    <div class="get-in-touch">
        <div class="wrapper">
            <h2>Ainda possui dúvidas?</h2>
            <p>Tire suas dúvidas sobre nossos serviços e produtos</p>
            <router-link to="/contato" tag="button" class="button">Fale conosco</router-link>
        </div>
    </div>
</template>
<script>
export default {
    name: "GetInTouch"
}
</script>
<style>
.get-in-touch{
    background: linear-gradient(30deg , #223467 0%, #32499b 90%);
    height: 100%;
    padding: 40px 0;
    color: #fff;
}
    .get-in-touch .wrapper{
        display: flex;
        flex-flow: column;
        align-items: center;
        align-content: center;
        justify-content: center;
    }
    .get-in-touch .wrapper h2, .get-in-touch .wrapper p{
        color: #fff;
    }
</style>